/**
 * Preditiva Gult Premium V2
 * Copyright (c) 2026 Preditiva. Todos os direitos reservados.
 * Tema proprietario - uso exclusivo clientes Preditiva.
 */
/**
 * pubsub.js — Sistema Pub/Sub para comunicação entre Custom Elements
 * Sistema Pub/Sub: subscribe() retorna unsubscribe function.
 */

let subscribers = {};

/**
 * Inscreve um callback para um evento.
 * @param {string} eventName - Nome do evento (de PUB_SUB_EVENTS)
 * @param {Function} callback - Função a ser chamada quando o evento for publicado
 * @returns {Function} unsubscribe - Função para cancelar a inscrição
 */
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

/**
 * Publica um evento para todos os inscritos.
 * @param {string} eventName - Nome do evento
 * @param {*} data - Dados a serem passados para os callbacks
 */
function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      try {
        callback(data);
      } catch (error) {
        console.error(`[pubsub] Erro no subscriber de '${eventName}':`, error);
      }
    });
  }
}
